import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

export const authGuard = () => {
  const keycloak = inject(KeycloakService);
  const router = inject(Router);

  const loggedIn = keycloak.isLoggedIn();

  if (loggedIn) {
    console.log('Functional AuthGuard: User is logged in : ', loggedIn);
    return true;
  } else {
    console.log('Functional AuthGuard: User is not logged in, redirection to /login');
    router.navigate(['/login']);
    return false;
  }
};